import escapeRegExp from "lodash/escapeRegExp"
import * as React from "react"
import { Search, Message, Label } from "semantic-ui-react"
import { isError } from "../../../utils"
import ButtonLock from "../buttons/com_button-lock"
import { IFormFieldProps } from "."
import ButtonChange from "../buttons/com_button-change"
import { permanentFormIds } from "../../../models"
import { PreviousValueMessage } from "./form-field-tools"

export default class SearchField extends React.Component<
  IFormFieldProps<string>,
  any
> {
  public constructor(props: IFormFieldProps<string>) {
    super(props)
    this.state = { isLoading: false, results: [] }
  }

  public shouldComponentUpdate(
    nextProps: IFormFieldProps<string>,
    nextState: any
  ) {
    let mustRender = false
    mustRender = mustRender || this.props.label !== nextProps.label
    mustRender = mustRender || this.props.data.lock !== nextProps.data.lock
    mustRender = mustRender || this.props.disabled !== nextProps.disabled
    mustRender = mustRender || this.props.oldValue !== nextProps.oldValue
    mustRender =
      mustRender || this.props.data.errorText !== nextProps.data.errorText
    mustRender = mustRender || this.props.data.value !== nextProps.data.value
    mustRender = mustRender || this.state.open !== nextState.open
    mustRender = mustRender || this.state.isLoading !== nextState.isLoading
    mustRender = mustRender || this.state.results !== nextState.results
    mustRender = mustRender || this.state.label !== nextState.label
    mustRender =
      mustRender || this.props.data.modified !== nextProps.data.modified

    return mustRender
  }

  public resetComponent = () => {
    this.props.onChange({
      code: this.props.data.code,
      fieldValue: "",
      lock: this.props.data.lock,
      fieldType: this.props.data.fieldType,
    })
    this.setState({ isLoading: false, results: [] })
  }

  public handleResultSelect = (e: any, { result }: any) => {
    this.props.onChange({
      code: this.props.data.code,
      fieldValue: result.text,
      lock: this.props.data.lock,
      fieldType: this.props.data.fieldType,
    })
  }

  public handleSearchChange = (e: any, { value }: any) => {
    if (value.length < 1) {
      return this.resetComponent()
    }

    const re = new RegExp(escapeRegExp(value), "i")
    const isMatch = (result: any) => re.test(result.text)

    const results =
      this.props.searchProps && this.props.searchProps.options
        ? this.props.searchProps.options.filter(isMatch)
        : []

    this.props.onChange({
      code: this.props.data.code,
      fieldValue: value,
      lock: this.props.data.lock,
      fieldType: this.props.data.fieldType,
    })
    this.setState({ isLoading: true })
    setTimeout(() => {
      this.setState({
        isLoading: false,
        results: results.slice(0, 10),
      })
    }, 300)
  }

  public resultRenderer = (props: any) => {
    return (
      <div>
        <h3>{props.text}</h3>
        <p>{props.value.Label}</p>
      </div>
    )
  }

  public render() {
    const {
      label = "",
      data,
      disabled = false,
      isNewProduct,
      onLockClick,
      tabIndex,
      onclick,
      style,
      formId,
      onModifyClick,
      oldValue,
      ...props
    } = this.props
    const { errorText, code, lock, value, isRequired, fieldType } = data
    const { isLoading, results }: any = this.state

    return (
      <div className="lock-div" style={style ? style.lockDiv || {} : {}}>
        {oldValue && oldValue.value !== value ? (
          <PreviousValueMessage
            label={oldValue.formattedDate}
            content={oldValue.value}
          />
        ) : (
          ""
        )}
        {isError(errorText) ? (
          <Message
            className="error-field-message"
            negative
            header={errorText}
          />
        ) : (
          ""
        )}
        <div className={"search-div " + (errorText ? "error-field" : "")}>
          <Label className="text-field-label dropdown-label" basic>
            {typeof label === "string"
              ? label + (isRequired ? "*" : "")
              : label}
          </Label>
          <Search
            // {...this.props}
            tabIndex={tabIndex}
            loading={isLoading}
            onResultSelect={this.handleResultSelect}
            onSearchChange={this.handleSearchChange}
            results={results}
            value={value}
            resultRenderer={this.resultRenderer}
            className={"search-field"}
          />
          {formId === permanentFormIds.MULTI_MODIF && onModifyClick ? (
            <ButtonChange
              modified={data.modified}
              onClick={onModifyClick}
              code={code}
              fieldType={fieldType}
            />
          ) : (
            <ButtonLock
              hidden={!isNewProduct}
              lockable={props.lockable}
              onClick={onLockClick}
              code={code}
              lock={lock}
              fieldType={fieldType}
            />
          )}
        </div>
      </div>
    )
  }
}
